module.exports = __webpack_public_path__ + "a7c49892c41fc65964eefc20ada906ba.pdf";